import * as React from "react";

import PropTypes from "prop-types";
import { Zoom, useScrollTrigger } from "@material-ui/core";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";

import theme from "../../../themes/theme.module.css";

import Tooltip, { ICON_NONE } from "../Tooltip/Tooltip";

const BackToTop = ({
  topRef,
  honeycomb,
  threshold,
  top,
  left,
  right,
  bottom,
}) => {
  const trigger = useScrollTrigger({
    threshold,
    disableHysteresis: true,
  });

  const handleClick = () => {
    honeycomb.sendUiInteractionSpan(`clicked-back-to-top`);

    if (topRef) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const style = {
    position: "fixed",
    zIndex: 99,
    padding: 0,
    backgroundColor: "transparent",
    paddingBottom: 10,
  };

  const map = { bottom, right, top, left };

  Object.keys(map).forEach((key) => {
    if (map[key] !== null) style[key] = `${map[key]}px`;
  });

  return (
    <Zoom in={trigger}>
      <IconButton
        color="inherit"
        sx={{ flexDirection: "column" }}
        style={style}
        onClick={handleClick}
      >
        <Tooltip iconType={ICON_NONE} title="Back to top">
          <KeyboardArrowUpIcon
            sx={{
              backgroundColor: theme.grey300,
              color: theme.grey100,
              width: 42,
              height: 42,
              borderRadius: 21,
              border: "solid 4px #DDD",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: theme.grey500,
                color: theme.grey50,
              },
            }}
          />
        </Tooltip>
      </IconButton>
    </Zoom>
  );
};

export default BackToTop;

BackToTop.defaultProps = {
  topRef: null,
  top: null,
  left: null,
  right: 0,
  bottom: 100,
  threshold: 600,
};

BackToTop.propTypes = {
  topRef: PropTypes.shape(),
  honeycomb: PropTypes.shape({ sendUiInteractionSpan: PropTypes.func })
    .isRequired,
  threshold: PropTypes.number,
  top: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
};
